import { render, staticRenderFns } from "./ProjectTestGroupList.vue?vue&type=template&id=4d6283f6&scoped=true&"
import script from "./ProjectTestGroupList.vue?vue&type=script&lang=ts&"
export * from "./ProjectTestGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectTestGroupList.vue?vue&type=style&index=0&id=4d6283f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6283f6",
  null
  
)

export default component.exports